import { actionTypes } from "./actions";

const updateStatus = (state, data) => {
  const newState = Object.assign({}, data, {
    isLicensingEnabled: true,
    isRegistered: Boolean(data.isRegistered),
    isReadOnlyMode: Boolean(data.isReadOnlyMode),
    isTrialStarted: Boolean(data.isTrialStarted),
    isTrialExpired: Boolean(data.isTrialExpired)
  });
  return state.merge(newState);
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_REGISTRATION_STATUS:
      return updateStatus(state, action.data);
    default:
      return state;
  }
};

export default reducer;
